import { useCallback, useEffect, useState } from 'react';
import { getWeeklyNotesForScopes, WeekNote, WeekNoteScope } from '@features/whereabouts/services/WeekNotesService';
import { Moment } from "moment";

export function WithWeeklyNotes(scopes: WeekNoteScope[], date: Moment) {
  const [loading, setLoading] = useState(false);
  const [requested, setRequested] = useState(true);
  const [notes, setNotes] = useState<WeekNote[]>([])

  const makeRequest = useCallback(async () => {
    setRequested(true);
    setLoading(true);
    try {
      const resp = await getWeeklyNotesForScopes(scopes, date)
      setNotes(resp)
    } finally {
      setLoading(false);
    }
  }, [date, scopes])

  useEffect(() => {
    if (!scopes || scopes.length === 0 || !date || loading || requested) return;
    setRequested(true);
    setLoading(true);
    makeRequest();
  }, [date, loading, makeRequest, requested, scopes])

  useEffect(() => {
    if (scopes && scopes.length > 0 && date) {
      setRequested(false);
    }
  }, [scopes, date]);

  return {
    loading: loading,
    hasRequested: requested,
    notes: notes,
    load: makeRequest,
  }
}
